import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.boletinscartaopontotrabalhadores.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        console.log(err)
        dispatch('ActionSetMsg',err)
    })
}
export const ActionCadastroDadosBoletim = ({dispatch},payload)=>{
    return serves.boletinscartaopontotrabalhadores.cadastradadosboletim(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionUpdateDadosBoletim = ({dispatch},payload)=>{
    return serves.boletinscartaopontotrabalhadores.updateboletim(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.boletinscartaopontotrabalhadores.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.boletinscartaopontotrabalhadores.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.boletinscartaopontotrabalhadores.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionMostrar = ({dispatch},payload)=>{
    console.log('ok');
    return serves.boletinscartaopontotrabalhadores.mostrar(payload).then(res => {
        dispatch('ActionSetBoletins',res)
    }).catch(err => {
        dispatch('ActionSetBoletins',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.boletinscartaopontotrabalhadores.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionHorarios = ({dispatch},payload)=>{
    return serves.boletinscartaopontotrabalhadores.horarios(payload).then(res => {
        dispatch('ActionSetHorarios',res)
    }).catch(err => {
        dispatch('ActionSetHorarios',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetBoletins = ({commit},payload) =>{
    commit(types.SET_BOLETINS,payload)
}
export const ActionSetHorarios = ({commit},payload) =>{
    commit(types.SET_HORARIOS,payload)
}
